var _path, _rect, _rect2, _rect3, _rect4, _rect5, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLayout10 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 160 90"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#666",
  d: "M0 0h160v90H0z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 42,
  height: 6,
  x: 30,
  y: 6,
  fill: "#CCC",
  rx: 3
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 84,
  x: 79.5,
  y: 3,
  fill: "#CCC",
  rx: 0.5
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 42,
  height: 6,
  x: 88,
  y: 6,
  fill: "#CCC",
  rx: 3
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 6,
  x: 138,
  y: 6,
  fill: "#CCC",
  rx: 3
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 6,
  x: 6,
  y: 6,
  fill: "#CCC",
  rx: 3
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M6 18h72v6.5H6zM6 26.5h72V33H6zM6 35h72v6.5H6zM6 43.5h72V50H6zM6 52h72v6.5H6zM6 60.5h72V67H6zM6 69h72v6.5H6zM6 77.5h72V84H6zM82 18h72v6.5H82zM82 26.5h72V33H82zM82 35h72v6.5H82zM82 43.5h72V50H82zM82 52h72v6.5H82zM82 60.5h72V67H82zM82 69h72v6.5H82zM82 77.5h72V84H82z"
})));
export { SvgLayout10 as ReactComponent };